import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Map, Radio, Library } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';

// Pulse Producer custom icon (musical note / corchea)
const ProducerIcon = ({ size = 20, strokeWidth = 1.5 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export function BottomNav() {
  const { t, lang } = useLang();
  const location = useLocation();

  const links = [
    { to: '/', icon: Home, label: t('nav.feed') },
    { to: '/events', icon: Map, label: t('nav.map') },
    { to: '/live', icon: Radio, label: lang === 'es' ? 'Vivo' : 'Live' },
    { to: '/library', icon: Library, label: lang === 'es' ? 'Colección' : 'Library' },
  ];

  if (location.pathname.startsWith('/dashboard')) return null;

  const isProducerActive = location.pathname === '/producer';

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden glass border-t border-white/10"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex items-center justify-around h-16 px-1">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-1 rounded-xl transition-colors duration-200 ${
                isActive
                  ? 'text-pulse-primary'
                  : 'text-pulse-muted hover:text-white'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={20} strokeWidth={isActive ? 2.5 : 1.5} />
                <span className="text-[9px] font-medium">{label}</span>
              </>
            )}
          </NavLink>
        ))}

        {/* Pulse Producer — golden highlighted tab */}
        <NavLink
          to="/producer"
          data-testid="nav-producer"
          className="flex flex-col items-center gap-0.5 px-2 py-1 rounded-xl transition-all duration-200 relative"
        >
          {({ isActive }) => (
            <>
              {/* Glow ring when active */}
              {isActive && (
                <span className="absolute inset-0 rounded-xl opacity-20" style={{ background: 'radial-gradient(circle, #F5C842, transparent)' }} />
              )}
              <div
                className="relative w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200"
                style={{
                  background: isActive
                    ? 'linear-gradient(135deg, #F5C842, #FF6B00)'
                    : 'linear-gradient(135deg, rgba(245,200,66,0.25), rgba(255,107,0,0.15))',
                  boxShadow: isActive ? '0 0 16px rgba(245,200,66,0.5)' : 'none',
                }}
              >
                <ProducerIcon
                  size={18}
                  strokeWidth={isActive ? 2.5 : 2}
                />
              </div>
              <span
                className="text-[9px] font-bold"
                style={{ color: isActive ? '#F5C842' : '#F5C842CC' }}
              >
                Producer
              </span>
            </>
          )}
        </NavLink>
      </div>
    </nav>
  );
}
